import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';
import { APIs } from 'src/app/_Core/_Constants/api.constant';
import { map } from 'rxjs/operators';
import { Injectable } from "@angular/core";


@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private apiSrv: ApiService) { }

  uploadImage(event) {
    return new Promise((resolve, reject) => {
      let url: string | ArrayBuffer;
      console.log('came here 1', event.target);
      if (event.target.files && event.target.files[0]) {
        console.log(event.target.files[0].size);
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          console.log('event', event);
          url = event.target.result;
          resolve(url);
        };
      }
    });
  }

  getGSTDetail() {
    return this.apiSrv.get(APIs.getGSTDetail).pipe(
      map((res) => {
        return res?.list;
      })
    );
  }

  getCanCalunit() {
    return this.apiSrv.get(APIs.GetFacilityCancellationUnit).pipe(
      map((res) => {
        return res.list;
      })
    );
  }

  getMyCompanyDetails(parkTenantId: string, parkId: string): Observable<any> {
    return this.apiSrv.get(`${APIs.getMyCompanyDetails}?parkTenantId=${parkTenantId}&parkId=${parkId}&pageNo=1&size=5`).pipe(map(response => {
      return response;
    }))
  }

  revokeEmployeeRights(payload) {
    return this.apiSrv.post(APIs.revokeEmployeeRights, payload).pipe(map(response => {
      return response;
    }))
  }

  saveEmployees(payload) {
    return this.apiSrv.post(APIs.saveEmployees, payload).pipe(map(response => {
      return response;
    }))
  }

  getBuildingByParkId(parkId) {
    return this.apiSrv.get(`${APIs.getBuildingByParkId}?parkId=${parkId}`).pipe(map(response => {
      return response;
    }))
  }

  getEmployeeListByFilter(payload) {
    return this.apiSrv.post(APIs.employeeListByFilter, payload).pipe(map(response => {
      return response;
    }))
  }

  giveEmployeeVMSInvitationRights(payload) {
    return this.apiSrv.post(APIs.employeeVmsInvitationRights, payload).pipe(map(response => {
      return response;
    }))
  }

  saveEmployeeStatus(payload) {
    return this.apiSrv.post(APIs.saveEmployeeStatus, payload).pipe(map(response => {
      return response;
    }))
  }

  getBuildingByParkIdAndTenatID(parkId, tenantId) {
    return this.apiSrv.get(`${APIs.getBuildingByParkIdAndTenatID}?parkId=${parkId}&parkTenantId=${tenantId}`).pipe(map(response => {
      return response;
    }))
  }

  verfiyEmployee(payload) {
    return this.apiSrv.post(APIs.verifyEmail, payload).pipe(map(response => {
      return response;
    }))
  }

  getEmployeeDetails(name, tenantId) {
    return this.apiSrv.get(`${APIs.getEmployeeDetailsByTenantId}?parkTenantId=${tenantId}&ParkUserId=${name}`).pipe(map(response => {
      return response;
    }))
  }

  getEmployeeListBasedonTenant(payload) {
    return this.apiSrv.post(APIs.EmployeeListBasedonTenant, payload).pipe(map(response => {
      return response;
    }))
  }

  markAsErt(payload) {
    return this.apiSrv.post(APIs.markAsErt, payload).pipe(map(response => {
      return response;
    }))
  }

  markAsCoadmin(payload) {
    return this.apiSrv.post(APIs.markAsCoadmin, payload).pipe(map(response => {
      return response;
    }))
  }

  getCompanyByTenantId(parkTenantId) {
    return this.apiSrv.get(`${APIs.getCompaniesByTenantId}?ParkTenantId=${parkTenantId}`).pipe(map(response => {
      return response;
    }))
  }

  saveCompany(payload) {
    return this.apiSrv.post(APIs.saveCompany, payload).pipe(map(response => {
      return response;
    }))
  }

  updateMeetingRoom(data) {
    return this.apiSrv.post(APIs.updateMeetingRoomDetail, data).pipe(
      map((res) => {

        return res;
      })
    );
  }

  AddMeetingRoom(data) {
    return this.apiSrv.post(APIs.saveMeetingRoom, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getAllAmenities() {
    return this.apiSrv.get(APIs.getAllAmenities).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getAllParkMeetingRooms(id: string, paymentStatus, parkTenantId): Observable<any> {
    return this.apiSrv.get(APIs.listAllParkMeetingRoom + '?parkId=' + id + '&paymentStatus=' + paymentStatus + '&parkTenantId=' + parkTenantId).pipe(map(response => {
      return response;
    }));
  }

  getMeetingRoomDetails(id: string): Observable<any> {
    return this.apiSrv.get(APIs.detailsParkMeetingRoom + '?parkMeetingRoomId=' + id + '&isPortal=web').pipe(map(response => {
      return response.data;
    }));
  }

  deleteParkMeetingRoom(body): Observable<any> {
    return this.apiSrv.post(APIs.deleteParkMeetingRoom, body).pipe(map(response => {
      return response;
    }));
  }

  bookNewMeetingRoom(body): Observable<any> {
    return this.apiSrv.post(APIs.createParkMeetingRoomCalendar, body).pipe(map(response => {
      return response;
    }));
  }

  getAllMeetingRoomBlockData(data) {
    return this.apiSrv.post(APIs.getAllBlockDatesMeeting, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getMeetingRoomTimeLine(data) {
    return this.apiSrv.post(APIs.getMeetingRoomTimeLine, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  // cancelBlockedMeetingRoom(data): Observable<any> {
  //   return this.apiService.post(APIs.cancelBlockedMeeting, data).pipe(map(response => {
  //     return response;
  //   }));
  // }

  cancelBlockedMeetingRoom(id: string): Observable<any> {
    return this.apiSrv.delete(APIs.cancelBlockedMeeting + '?meetingroomCalendarId=' + id).pipe(map(response => {
      return response;
    }));
  }

  // cancelBookedMeetingRoom(id: string): Observable<any> {
  //   return this.apiService.delete(APIs.cancelBookedMeeting + '?bookingId=' + id).pipe(map(response => {
  //     return response;
  //   }));
  // }

  bookedParkMeetingRooms(data): Observable<any> {
    return this.apiSrv.post(APIs.bookedMeetingRoomList, data).pipe(map(response => {
      return response;
    }));
  }

  cancelBookedMeetingRoom(data) {
    return this.apiSrv.put(APIs.cancelBookedMeeting, data).pipe(map((res) => {
      return res;
    }));
  }

  updateFaclitiesImage(data) {
    return this.apiSrv.post(APIs.setFacilityTypeImage, data).pipe(
      map((res) => {
        return res.list;
      })
    );
  }

  fetchFacilityBookingTypes() {
    return this.apiSrv.get(APIs.getFacilytyBookingType).pipe(
      map((res) => {
        return res;
      })
    );
  }

  regenerateCompanySecuritPassword(payload) {
    return this.apiSrv.post(APIs.regenerateTenantSecurityPassword, payload).pipe(map(response => {
      return response;
    }))
  }
}
